/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createQuote } from "@eisinc/App/Services/QuoteService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateOrRequestQuote,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";

export const XngPopulateApiParameter: any = (props: any) => {
    const quoteParameter = props.getState().pages.rfqRequestQuote.quoteParameter;
    const poNumber = props.parameter.poNumber;
    const { quoteId, jobName, quoteType, accountId, note } = quoteParameter;
    props.apiParameter = {
        quoteId,
        jobName,
        isJobQuote: quoteType === "job",
        userId: accountId,
        note,
        poNumber,
    };
};

export const XngCreateOrRequestQuote: any = async (props: any) => {
    const { parameter, apiParameter } = props;
    const result = await createQuote(apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, CreateOrRequestQuote, XngCreateOrRequestQuote);
